import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';

import {refresh as paginatorRefresh} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import filtersSelectorGenerator from './filters';


export default class Schools extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object, 
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: 'name', label: window.gettext('Name')},
        {field: item => _.map(item.levels, level => level.title).join(window.gettext(',') + ' '), label: window.gettext('Level')},
        {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
        {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
        {field: item => item.gender === 1 ? window.gettext('Male') : window.gettext('Female'), label: window.gettext('Gender')},
        {field: 'phone_number', label: window.gettext('Phone')},
        {
            field: item => item.category ? item.category.title : '',
            label: window.gettext('Category'),
        },
    ]

    filtersSelector = filtersSelectorGenerator.bind(this)()

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'name', label: window.gettext('Name')},
        {name: 'city', label: window.gettext('City')},
        {name: 'region', label: window.gettext('Region')},
    ]

    editProps = {exclude: 'classes'}

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            label: window.gettext('Mass Edit'),
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New School'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
            ]),
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='school'
            style={this.style}
            fixedColumns={2}
            title={window.gettext('Schools')}
            listFields={this.listFields}
            selectable={this.props.selectable}
            filters={this.filtersSelector(this.props.store)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.buttonActionsSelector(this.props.store)}
            editProps={this.editProps}
        />;
    }
}
